import moment from "moment";

export const onFilter = () => (dataIndex, value, record) =>
  record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());

const getDate = (dateString) => {
  var dateParts = dateString.split("/");
  var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  return dateObject.getTime();
};

const parseSingleRecord = (record) => {
  // Handle both camelCase and snake_case formats from backend
  const user = record.user || {};

  // Parse amount and remaining amount - handle both string and number types
  const parseAmount = (value) => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  };

  return {
    bookingId: record.booking_id || record.bookingId || "",
    transactionId: record.transaction_id || record.transactionId || "",
    turf:
      record.turf_number === 1
        ? "A"
        : record.turf_number === 2
        ? "B"
        : record.turf_number === 3
        ? "C"
        : record.turf_number || "",
    bookingDate: record.booking_timestamp
      ? moment(new Date(record.booking_timestamp)).format("DD/MM/yyyy")
      : record.bookingTimestamp
      ? moment(new Date(record.bookingTimestamp)).format("DD/MM/yyyy")
      : "",
    playingDate: record.slot_date || record.slotDate || "",
    startTime: record.slot_time || record.slotTime || "",
    duration: record.duration || "",
    amount: parseAmount(record.amount) + " ₹",
    remainingAmount: parseAmount(record.remaining_amount) + " ₹",
    sport: record.sport || "",
    bookingStatus: record.booking_status || record.bookingStatus || "",
    location: record.location || "",
    name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
    mobileNo: user.mobile_number || "",
  };
};

const parseMyBookingsList = (list) => list.map((i) => parseSingleRecord(i));

export const parseMyBookings = (list) => {
  if (!list || !Array.isArray(list)) {
    return {
      past: [],
      today: [],
      upcoming: [],
    };
  }

  const result = parseMyBookingsList(list).reduce(
    (acc, item) => {
      const tday = moment(new Date()).format("DD/MM/yyyy");

      if (getDate(tday) > getDate(item.playingDate)) {
        return { ...acc, past: [...acc.past, item] };
      }
      if (getDate(tday) < getDate(item.playingDate)) {
        return { ...acc, upcoming: [...acc.upcoming, item] };
      }
      return { ...acc, today: [...acc.today, item] };
    },
    {
      past: [],
      today: [],
      upcoming: [],
    }
  );

  return result;
};

export const getBookingTimeFrame = (date) => {
  const tday = moment(new Date()).format("DD/MM/yyyy");

  if (getDate(tday) > getDate(date)) {
    return "past";
  }

  if (getDate(tday) < getDate(date)) {
    return "upcoming";
  }

  return "today";
};
